module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Shift-8e98c4081354c73ad88aec73fffda8a6.svg";